import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  color: white;
  min-height: 100vh;
  font-family: ${(props) => props.theme.fonts.sfcompact};
  animation-duration: 1s;
  animation-name: appear;
  position: relative;

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: background-color 0.6s ease;
    pointer-events: none;
    z-index: 1;
  }

  > *:not(.world-map-background) {
    position: relative;
    z-index: 2;
  }

  .world-map-background {
    z-index: 0 !important;
  }

  .title {
    color: rgb(244, 80, 28);
    font-size: 20px;
    font-family: Oswald, sans-serif;
  }

  .filtersContainer {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-gap: 20px;
    width: 100%;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      grid-template-columns: repeat(2, 1fr);
    }

    > * {
      align-self: flex-start;
    }

    .label {
      margin-bottom: 15px;
    }

    > .title {
      color: #2b3d54;
    }

    .labelContainer .label {
      font-size: 12px;
    }
  }

  .filtersContainerSlideRange {
    display: flex;

    .labelContainer {
      display: flex;
      justify-content: center;
    }

    .label {
      font-size: 12px;
      font-family: ${(props) => props.theme.fonts.oswald};
      text-transform: uppercase;
      color: rgb(43, 61, 84);
      margin-bottom: 7px;
    }
  }

  .headerContent {
    margin-top: 2%;
    margin-bottom: 2%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  > .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 24px;
  }

  .subtitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 37px;
    text-transform: uppercase;
    margin-top: 10px;
  }

  .filter-container {
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    margin: 20px;
    background-color: white;
  }

  input[type='range'] {
    -webkit-appearance: none;
    height: 5px;
    background: #ddd;
    border-radius: 5px;
  }

  .bodyContainer {
    z-index: 3;
    padding: 30px 7vw;

    @media (max-width: 1200px) {
      padding: 20px 5vw;
    }

    @media (max-width: 845px) {
      padding: 1rem 1rem 4rem;
      width: calc(100vw - 32px);
    }
  }

  .mapboxgl-ctrl-bottom-right {
    display: none !important;
  }

  .mapboxgl-ctrl-logo {
    display: none !important;
  }

  .filter-slider-price {
    padding-left: 25%;
    padding-right: 25%;

    .title {
      color: #2b3d54;
      font-size: 12px;
      text-align: center;
      font-family: Oswald, sans-serif;
    }
  }

  .ant-btn {
    border: none;
  }

  .ant-btn.button-type-table {
    font-size: 12px;
    font-family: Oswald, sans-serif;
    padding: 4px 22px;
    font-weight: 400;
  }

  .ant-btn.ant-btn-default.button-type-table {
    background-color: #66696c;
    color: white;
    border-width: 0;
  }

  .ant-btn.ant-btn-default.button-type-table:hover {
    background-color: #66696c;
  }

  .filter-input {
    width: 100%;
    max-width: 400px;
    border-radius: 4px;
    background-color: transparent;
    font-family: Oswald, sans-serif;
    color: white;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      max-width: calc(100vw - 66px);
    }
    input::placeholder {
      font-family: Oswald, sans-serif;
      color: rgb(255 255 255/0.5);
    }
  }

  .ant-btn.button-clear-filters {
    border-radius: 24px;
    padding: 5px 15px;
    font-family: Oswald, sans-serif;
  }

  .ant-btn.button-clear-filters {
    border-radius: 24px;
    font-family: Oswald, sans-serif;
  }

  .ant-btn.button-clear-filters.ant-btn-text:not(:disabled):not(
      .ant-btn-disabled
    ) {
    color: white;
  }

  .ant-btn.button-clear-filters.ant-btn-text:not(:disabled):not(
      .ant-btn-disabled
    ) {
    color: #e25d34;
    &:hover {
      color: white;
      background-color: #66696c;
    }
  }

  .ant-btn.button-clear-filters .ant-btn-icon {
    position: relative;
    left: -10px;
  }

  .ant-btn.button-clear-filters {
    span:not(.ant-btn-icon, .icon) {
      top: -5px;
      position: relative;
    }
  }

  .ant-card .header-card-title {
    color: white;
    align-content: center;
    font-family: Oswald, sans-serif;
  }

  .kpi-content {
    display: grid;
    gap: 20px;
    padding-bottom: 20px;

    .ant-card-head-title > div {
      @media (max-width: ${(props) =>
          props.theme.devices.isTablet ? '0px' : '845px'}) {
        flex-direction: column;
        align-items: flex-start !important;
        gap: 10px !important;
      }
    }
  }

  .kpi-content .kpi-title-anticon {
    color: #e25d34;
    font-size: 24px;
  }

  .ant-card-bordered {
    border: 1px solid #f0f0f070;
  }

  .rightComponentsHeader {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .exportButtonContainer {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 10px;
    height: 10px;
  }

  .ant-segmented {
    box-shadow: rgba(9, 23, 71, 0.3) 2px 2px 4px 0;
    color: #e5eef5;
    border-radius: 25px;

    .ant-segmented-item-selected {
      border-radius: 25px;
    }

    .ant-segmented-item-disabled,
    .ant-segmented-item-disabled:hover,
    .ant-segmented-item-disabled:focus {
      color: #adb4bc;
    }

    .ant-segmented-item:hover:not(.ant-segmented-item-selected):not(
        .ant-segmented-item-disabled
      ) {
      color: #adb4bc;
    }
  }

  .slider-container {
    display: flex;
    gap: 20px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      justify-content: center;
    }
  }

  .pos-cell-clickable {
    cursor: pointer;
    transition: text-decoration 0.2s ease;

    &:hover {
      text-decoration: underline;
    }
  }

  .ant-table-container {
    width: calc(100vw - 14vw - 148px);

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '1200px'}) {
      width: calc(100vw - 10vw - 148px);
    }

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: calc(100vw - 64px);
    }
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    border: none !important;
    border-radius: 4px;
    color: ${(props) => props.theme.colors['white']};
    padding: 0 16px;
  }

  .ant-select-single.ant-select-open .ant-select-selection-item {
    color: ${(props) => props.theme.colors['white']};
  }

  .ant-select .ant-select-arrow {
    color: white;
  }

  .ant-select-selection-item {
    font-size: 16px;
  }

  .navButtonMobile {
    font-size: 12px;
  }

  .filter-search-input.ant-input-affix-wrapper {
    padding: 0;
  }

  .filter-search-input.ant-input-affix-wrapper .ant-input {
    height: 25px;
    font-family: Oswald, sans-serif;
    font-size: 14px;
    color: #2b3d54;
  }

  .filter-search-input.ant-input-affix-wrapper .ant-input::placeholder {
    color: rgba(43, 61, 84, 0.5);
    font-family: Oswald, sans-serif;
  }

  .filter-search-input.ant-input-affix-wrapper .ant-input-suffix {
    color: #2b3d54;
  }

  .paginationContainer {
    position: fixed;
    bottom: 20px;
    left: 90px;
    width: calc(100% - 90px);
    text-align: center;
    z-index: 1;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      left: 0;
      width: 100vw;
    }
  }
`;

export default Container;
